import {useConnect} from '@lore/query-connect';
import {parse} from 'query-string';
import useStewardshipFilter from './useStewardshipFilter';
import getQueryUtils, {attributeKeys} from './queryUtils';
import useNetwork from "../../hooks/useNetwork";

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 10
  } = props;

  let stewardshipFilter = useStewardshipFilter();

  const queryUtils = getQueryUtils(search, attributeKeys);
  const network = useNetwork();

  // If applied, sites must have at least one network.
  const networkFilter = {
    $having: {
      count: {
        $gt: 0
      }
    },
  };
  const mustHaveNetwork = network ? networkFilter : undefined

  // if a network is defined, filter by the specified network (steward filter).
  // When no network is defined (None, Nationwide USA), filter by any network OR active site. This will show active
  // sites with no network and sites associated with any network.
  if (!network) {
    stewardshipFilter = {
      networks: networkFilter,
      isActive: true
    }
  }

  return useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: `numberOfProjectsCompleted`,
            relation: 'projects',
            $where: {
              activityId: {
                $null: false
              },
              completed: true
            }
          },
          {
            type: 'count',
            alias: `numberOfProjectsCancelled`,
            relation: 'projects',
            $where: {
              activityId: {
                $null: false
              },
              cancelled: true
            }
          },
          {
            type: 'count',
            alias: `numberOfProjectsActive`,
            relation: 'projects',
            $where: {
              activityId: {
                $null: false
              },
              completed: false,
              cancelled: false
            }
          },
          {
            type: 'count',
            alias: `numberOfEventsCompleted`,
            relation: 'events',
            $where: {
              activityId: {
                $null: false
              },
              completed: true
            }
          },
          {
            type: 'count',
            alias: `numberOfEventsCancelled`,
            relation: 'events',
            $where: {
              activityId: {
                $null: false
              },
              cancelled: true
            }
          },
          {
            type: 'count',
            alias: `numberOfEventsActive`,
            relation: 'events',
            $where: {
              activityId: {
                $null: false
              },
              completed: false,
              cancelled: false
            }
          }
        ],
        $where: {
          $and: [...queryUtils.where],
          networks: mustHaveNetwork,
          $or: stewardshipFilter
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
